import { common } from './common.ts'
import { header } from './layout'
import integrations from './integrations'
import {
	blogListing,
	blogPostsCarousel,
	productsCarousel,
	reviewsCarousel,
	slider,
} from './sections'
import blocks from './blocks'

header()
slider()
reviewsCarousel()
blogPostsCarousel()
productsCarousel()
common()
blogListing()

blocks()
integrations()